import { FC, useContext } from "react"
import { LoaderContext } from "../../context/loaderContext";

const HubLoader: FC = (): JSX.Element => {
  const { isVisible } = useContext(LoaderContext);

  return (
            // <div className={`spinner-overlay ${isVisible ? 'd-flex' : 'd-none'}`}>
            //   <div className="spinner-border text-secondary" role="status">
            //     <span className="visually-hidden">Loading...</span>
            //   </div>
            // </div>
       <></>
  );
};

export default HubLoader;
